/* eslint-disable react/jsx-props-no-spreading */
import MicromagConsent from '@micromag/consent';
import { IntlProvider } from '@micromag/intl';
import classNames from 'classnames';
import React, { useEffect, useCallback, useRef } from 'react';

import useKeyboardKeys, { KEYS } from '../../hooks/useKeyboardKeys';

import { useLocale } from '../../contexts/LocaleContext';
import { useModal } from '../../contexts/ModalContext';

import styles from '../../styles/modals/consent.module.css';

interface ConsentProps {
    className?: string | null;
}

function Consent({ className = null }: ConsentProps) {
    const modalRef = useRef(null);

    const { locale = null, messages = null } = useLocale();
    const { modal = null, setModal, unsetModal } = useModal();

    const onClose = useCallback(() => {
        unsetModal(modal);
        setModal(null);
    }, [setModal, unsetModal, modal]);

    const visible = modal !== null;

    useEffect(() => {
        if (modal !== null) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [modal]);

    useKeyboardKeys({
        [KEYS.ESCAPE]: onClose,
    });

    return (
        <div
            className={classNames([
                styles.container,
                className,
                {
                    [styles.visible]: visible,
                },
            ])}
        >
            <div className={styles.wrapper} ref={modalRef}>
                <IntlProvider locale={locale} messages={messages}>
                    <div className={styles.inner}>
                        <MicromagConsent
                            className={styles.consent}
                            onConfirm={onClose}
                            onClose={onClose}
                        />
                    </div>
                </IntlProvider>
            </div>
            <div className={styles.lightBox} />
        </div>
    );
}

export default Consent;
